import React from 'react';
import type { FlagsMapper } from '@atlassian/jira-flags';
import type { FlagComponentProps } from '@atlassian/jira-flags/src/services/types';
import {
	AvatarFetchFailedFlag,
	AvatarUploadFailedFlag,
} from '@atlassian/jira-project-settings-apps-common/src/avatar-service/avatar-flags.tsx';
import {
	SAVE_AVATAR_IMAGE_FAILURE,
	type SaveAvatarImageFailureAction,
	SHOW_FETCH_AVATARS_ERROR_FLAG,
	type ShowFetchAvatarsErrorFlagAction,
} from '../state/actions.tsx';
import type { State } from '../state/types.tsx';

type Action = SaveAvatarImageFailureAction | ShowFetchAvatarsErrorFlagAction;

const flagsMapper: FlagsMapper<Action, State> = (action: Action) => {
	switch (action.type) {
		case SAVE_AVATAR_IMAGE_FAILURE: {
			return (props: FlagComponentProps) => <AvatarUploadFailedFlag {...props} />;
		}
		case SHOW_FETCH_AVATARS_ERROR_FLAG: {
			return (props: FlagComponentProps) => <AvatarFetchFailedFlag {...props} />;
		}
		default:
			return undefined;
	}
};

export default flagsMapper;
